export default __webpack_public_path__ + "static/media/Saints.8ad3d763.jpg";